export default "__VITE_ASSET__DexkQ36v__"